import { NewsView } from '../../model/models';
interface NewsProps {
  news: NewsView[];
  baseUrl: string;
  itemRenderer: (news: NewsView, baseUrl: string, key: number) => JSX.Element;
}

export const NewsListSimple: React.FC<NewsProps> = ({
  news,
  baseUrl,
  itemRenderer,
}) => (
  <ul className="ion-list-news flex flex-col w-full">
    {news.map((item, index) => itemRenderer(item, baseUrl, index))}
  </ul>
);
